import { defineStore } from "pinia";

export interface UIStoreInterface {
    hideLogo: boolean;
}

export const useUIStore = defineStore({
    id: "ui",
    state(): UIStoreInterface {
        return {
            hideLogo: false,
        };
    },
    getters: {
        getHideLogo(): boolean {
            return this.hideLogo;
        },
    },
    actions: {
        setHideLogo(value: boolean): void {
            this.hideLogo = value;
        },
    },
});
